import FontIcon from './FontIcon';
export default FontIcon;
import _FontIcon from './FontIcon';
export { _FontIcon as FontIcon };